import { Box } from '@mui/material';
import { ReactNode } from 'react';

interface SectionWrapperProps {
  children: ReactNode;
}

const SectionWrapper = ({ children }: SectionWrapperProps) => (
  <Box
    sx={{
      display: 'block',
      height: '100%',
      overflowY: 'auto',
      flexGrow: 1,
      flexBasis: 0,
      paddingRight: '10px',
    }}
  >
    {children}
  </Box>
);

export default SectionWrapper;
